import type { NectarProject } from '../api/models'

export const MissionProjectHeader = ({ project }: { project: NectarProject }) => {
  return (
    <div className="flex flex-col gap-2 border-b border-solid border-gray-100 pb-6">
      <div className="text-h4">{project.name}</div>
      {project.description && <div className="text-gray-80 mt-2 max-w-[880px]">{project.description}</div>}
    </div>
  )
}
